import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import * as Cases from '../slices/casesSlice';
import { useAppDispatch, useAppSelector } from '../slices/index';
import { AnyAction } from 'redux';
import NavBar from './navbar';

const LoadCase = () => {
	const cases = useAppSelector(state => state.cases);
	const user = useAppSelector(state => state.user);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	useEffect(() => {
		dispatch(Cases.getCase(({ caseno: cases.case.caseno, type: cases.case.type, id: user.id, token: user.token })) as unknown as AnyAction).then((result: any) => {
			navigate('/case');
		});
	}, []);

	return (
		<div>
			<NavBar />
			<div className="centered" style={{ display: 'flex', flexDirection: 'column' }}>
				<div style={{ fontFamily: 'kanitbold' }}>LOADING CASE</div>
				<img src={require('../assets/bricks.gif')} style={{ width: 67, height: 34 }} alt='Bricks-GIF' />
			</div>
		</div>
	);
}

export default LoadCase;